<template lang="html">
    <div class="form-group" :class="[col ? col : 'col-lg-12']">
        <label :for="reference">{{ label }} <span v-if="required">*</span></label>
        <textarea
            class="form-control"
            :class="[error ? 'has-error' : '']"
            :id="reference"
            :value="value"
            rows="3">
        </textarea>
        <error :error="error"></error>
    </div>
</template>

<script>
import Error from "./Error.vue"

export default {
    components: {
        Error
    },
    props: {
        label: String,
        name: String,
        value: String,
        error: String,
        required: Boolean,
        col: String,
    },
    data() {
        return {
            editor: null,
            reference: null,
        }
    },
    mounted() {
        this.reference = Math.floor(Math.random()*1000000);
        this.$nextTick(() => {
            this.editor = tinymce.init({
                paste_as_text: true,
                menubar : false,
                selector: "#" + this.reference,
                plugins: "link code",
                toolbar1: "undo redo | formatselect variables | bold italic underline | alignleft alignright aligncenter alignjustify | bullist numlist | link | removeformat | code",
                setup: (editor) => {
                    editor.on('PreInit', () => {
                        // Create a custom node filter to remove unwanted content when getting content from the editor
                        editor.serializer.addNodeFilter('div', function(nodes) {
                            nodes.forEach(function(node) {
                                var id = node.attr('id');
                                if (id === 'ConnectiveDocSignExtentionInstalled') {
                                    node.remove();
                                }
                            });
                        });
                    });
                    // change event will update the original textarea so that the seo plugin keeps working
                    editor.on('change init paste input undo redo', () => {
                        var content = editor.getContent();
                        this.$emit('input', content);
                    });
                },
                relative_urls : false,
                remove_script_host : false,
                document_base_url: '/',
                convert_urls : true,
                table_default_styles: {
                    width: '100%'
                },
                fontsize_formats: "4pt 6pt 8pt 10pt 12pt 14pt 18pt 24pt 36pt",
                height: "15vh",
            });
        })
    }
}
</script>
